import { render, staticRenderFns } from "./Manage_article.vue?vue&type=template&id=f45e8186&scoped=true&"
import script from "./Manage_article.vue?vue&type=script&lang=js&"
export * from "./Manage_article.vue?vue&type=script&lang=js&"
import style0 from "./Manage_article.vue?vue&type=style&index=0&id=f45e8186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45e8186",
  null
  
)

export default component.exports